export default __webpack_public_path__ + "static/media/gallery2.4897be60.jpg";